import React from 'react';

const getValueFromJSX = (value: string | JSX.Element, headerId: string) => {
    if (React.isValidElement(value)) {
        return (value as JSX.Element)?.props?.[headerId] ?? '';
    }
    return value;
};

export function downloadCSV<T extends Record<string, any>>(
    dataArray: T[],
    headers: { label: string; id: keyof T }[],
    filename = 'Data'
): void {
    const csvHeaders = headers.map((header) => `"${header.label}"`).join(';');
    const csvContent = dataArray.map((obj) => {
        return headers
            .map((header) => `"${getValueFromJSX(obj[header.id], header.id) ?? ''}"`)
            .join(';');
    });
    csvContent.unshift(csvHeaders);
    const csvString = 'sep=;\n' + csvContent.join('\n');
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const tempLink = document.createElement('a');
    tempLink.href = URL.createObjectURL(blob);
    tempLink.setAttribute('download', `${filename}.csv`);
    tempLink.style.visibility = 'hidden';
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
}
